import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const CommunicationsRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/responsabile/marketing', search, hash }} replace />;
};